// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: uZHZeeP723
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import LoginInput from "../../LoginInput"; // plasmic-import: aQnFozGxZ1/component
import LoginPasswordInput from "../../LoginPasswordInput"; // plasmic-import: tgUi1FC4vi/component
import CustomErrorComponent from "../../CustomErrorComponent"; // plasmic-import: 42T9zhO9Sy/component
import LoginButton from "../../LoginButton"; // plasmic-import: TO8CcZyaHD/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicLoginPage.module.css"; // plasmic-import: uZHZeeP723/css
import vectorsZlhptEmGP from "./images/vectors.svg"; // plasmic-import: ZlhptEmG_P/picture

createPlasmicElementProxy;

export const PlasmicLoginPage__VariantProps = new Array();

export const PlasmicLoginPage__ArgProps = new Array();

const $$ = {};

function PlasmicLoginPage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"dashboardLoginDarkTheme"}
            data-plasmic-override={overrides.dashboardLoginDarkTheme}
            className={classNames(projectcss.all, sty.dashboardLoginDarkTheme)}
          >
            <p.Stack
              as={"div"}
              data-plasmic-name={"frame1"}
              data-plasmic-override={overrides.frame1}
              hasGap={true}
              className={classNames(projectcss.all, sty.frame1)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__wDnqL
                )}
              >
                {"Sign In"}
              </div>
              <div
                data-plasmic-name={"emailBox"}
                data-plasmic-override={overrides.emailBox}
                className={classNames(projectcss.all, sty.emailBox)}
              >
                <div
                  data-plasmic-name={"rectangle"}
                  data-plasmic-override={overrides.rectangle}
                  className={classNames(projectcss.all, sty.rectangle)}
                >
                  <LoginInput
                    data-plasmic-name={"loginEmailInput"}
                    data-plasmic-override={overrides.loginEmailInput}
                    className={classNames(
                      "__wab_instance",
                      sty.loginEmailInput
                    )}
                  />
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__s97Jj
                  )}
                >
                  {"Email"}
                </div>
              </div>
              <div
                data-plasmic-name={"invalidEmailText"}
                data-plasmic-override={overrides.invalidEmailText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.invalidEmailText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Invalid email address"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Invalid email address"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"username3"}
                data-plasmic-override={overrides.username3}
                className={classNames(projectcss.all, sty.username3)}
              >
                <div
                  data-plasmic-name={"rectangle4"}
                  data-plasmic-override={overrides.rectangle4}
                  className={classNames(projectcss.all, sty.rectangle4)}
                >
                  <LoginPasswordInput
                    data-plasmic-name={"loginPasswordInput"}
                    data-plasmic-override={overrides.loginPasswordInput}
                    className={classNames(
                      "__wab_instance",
                      sty.loginPasswordInput
                    )}
                  />
                </div>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__lc7K8
                  )}
                >
                  {"Password"}
                </div>
                <div
                  data-plasmic-name={"forgotPassword"}
                  data-plasmic-override={overrides.forgotPassword}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.forgotPassword
                  )}
                >
                  {hasVariant(globalVariants, "screen", "small")
                    ? "Forgot your password?"
                    : "Forgot your password?"}
                </div>
              </div>
              <div
                data-plasmic-name={"incorrectLoginText"}
                data-plasmic-override={overrides.incorrectLoginText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.incorrectLoginText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Incorrect email or password"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Incorrect email or password"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <CustomErrorComponent
                data-plasmic-name={"customErrorInstance"}
                data-plasmic-override={overrides.customErrorInstance}
                className={classNames(
                  "__wab_instance",
                  sty.customErrorInstance
                )}
              />

              <LoginButton
                data-plasmic-name={"loginButton"}
                data-plasmic-override={overrides.loginButton}
                className={classNames("__wab_instance", sty.loginButton)}
              />

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__dWvx
                )}
              >
                <React.Fragment>
                  <React.Fragment>
                    {"Don\u2019t have an account?  "}
                  </React.Fragment>
                  {
                    <span
                      data-plasmic-name={"signupText"}
                      data-plasmic-override={overrides.signupText}
                      className={classNames(
                        projectcss.all,
                        projectcss.span,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.signupText
                      )}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span"
                          }
                          style={{ color: "#0400FF" }}
                        >
                          {"Signup"}
                        </span>
                      </React.Fragment>
                    </span>
                  }

                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </div>
            </p.Stack>
            <p.PlasmicImg
              data-plasmic-name={"img"}
              data-plasmic-override={overrides.img}
              alt={""}
              className={classNames(sty.img)}
              displayHeight={"auto"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"auto"}
              loading={"lazy"}
              src={{
                src: vectorsZlhptEmGP,
                fullWidth: 1280,
                fullHeight: 111,
                aspectRatio: 11.531532
              }}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "dashboardLoginDarkTheme",
    "frame1",
    "emailBox",
    "rectangle",
    "loginEmailInput",
    "invalidEmailText",
    "username3",
    "rectangle4",
    "loginPasswordInput",
    "forgotPassword",
    "incorrectLoginText",
    "customErrorInstance",
    "loginButton",
    "signupText",
    "img"
  ],

  dashboardLoginDarkTheme: [
    "dashboardLoginDarkTheme",
    "frame1",
    "emailBox",
    "rectangle",
    "loginEmailInput",
    "invalidEmailText",
    "username3",
    "rectangle4",
    "loginPasswordInput",
    "forgotPassword",
    "incorrectLoginText",
    "customErrorInstance",
    "loginButton",
    "signupText",
    "img"
  ],

  frame1: [
    "frame1",
    "emailBox",
    "rectangle",
    "loginEmailInput",
    "invalidEmailText",
    "username3",
    "rectangle4",
    "loginPasswordInput",
    "forgotPassword",
    "incorrectLoginText",
    "customErrorInstance",
    "loginButton",
    "signupText"
  ],

  emailBox: ["emailBox", "rectangle", "loginEmailInput"],
  rectangle: ["rectangle", "loginEmailInput"],
  loginEmailInput: ["loginEmailInput"],
  invalidEmailText: ["invalidEmailText"],
  username3: [
    "username3",
    "rectangle4",
    "loginPasswordInput",
    "forgotPassword"
  ],

  rectangle4: ["rectangle4", "loginPasswordInput"],
  loginPasswordInput: ["loginPasswordInput"],
  forgotPassword: ["forgotPassword"],
  incorrectLoginText: ["incorrectLoginText"],
  customErrorInstance: ["customErrorInstance"],
  loginButton: ["loginButton"],
  signupText: ["signupText"],
  img: ["img"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicLoginPage__ArgProps,
          internalVariantPropNames: PlasmicLoginPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicLoginPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicLoginPage";
  } else {
    func.displayName = `PlasmicLoginPage.${nodeName}`;
  }
  return func;
}

export const PlasmicLoginPage = Object.assign(
  // Top-level PlasmicLoginPage renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    dashboardLoginDarkTheme: makeNodeComponent("dashboardLoginDarkTheme"),
    frame1: makeNodeComponent("frame1"),
    emailBox: makeNodeComponent("emailBox"),
    rectangle: makeNodeComponent("rectangle"),
    loginEmailInput: makeNodeComponent("loginEmailInput"),
    invalidEmailText: makeNodeComponent("invalidEmailText"),
    username3: makeNodeComponent("username3"),
    rectangle4: makeNodeComponent("rectangle4"),
    loginPasswordInput: makeNodeComponent("loginPasswordInput"),
    forgotPassword: makeNodeComponent("forgotPassword"),
    incorrectLoginText: makeNodeComponent("incorrectLoginText"),
    customErrorInstance: makeNodeComponent("customErrorInstance"),
    loginButton: makeNodeComponent("loginButton"),
    signupText: makeNodeComponent("signupText"),
    img: makeNodeComponent("img"),
    // Metadata about props expected for PlasmicLoginPage
    internalVariantProps: PlasmicLoginPage__VariantProps,
    internalArgProps: PlasmicLoginPage__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicLoginPage;
/* prettier-ignore-end */
